"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ShareSolid: function() {
        return ShareSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ShareSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15 5C15 2.79086 16.7909 1 19 1C21.2091 1 23 2.79086 23 5C23 7.20914 21.2091 9 19 9C17.7961 9 16.7164 8.46811 15.9831 7.6265L8.91208 11.162C8.96969 11.4322 9 11.7126 9 12C9 12.2874 8.96969 12.5678 8.91208 12.838L15.9831 16.3735C16.7164 15.5319 17.7961 15 19 15C21.2091 15 23 16.7909 23 19C23 21.2091 21.2091 23 19 23C16.7909 23 15 21.2091 15 19C15 18.7126 15.0303 18.4322 15.0879 18.162L8.01694 14.6265C7.28363 15.4681 6.20393 16 5 16C2.79086 16 1 14.2091 1 12C1 9.79086 2.79086 8 5 8C6.20393 8 7.28363 8.53189 8.01694 9.3735L15.0879 5.838C15.0303 5.56777 15 5.28742 15 5Z",
        fill: "currentColor"
    })
}), "ShareSolid");
const _default = ShareSolid;
